// extracted by mini-css-extract-plugin
export var root = "figure-module--root--1twpm";